import camelize from 'camelize-ts'

import { Space, SpacePayload } from '../types'

const fromPayload = (payload: SpacePayload) => camelize(payload) as Space

export default { fromPayload }
